import React from 'react';
import { Button } from "@/components/ui/Button";
import { ArrowRight, Search, Send, Users, CheckCircle, FileCheck, Handshake } from "lucide-react";

const processes = [
  {
    title: "Processus Lead Qualifié",
    icon: Search,
    steps: [
      {
        title: "Identification",
        description: "Vous identifiez un prospect potentiel qui correspond à nos critères de qualification.",
        icon: Search
      },
      {
        title: "Qualification",
        description: "Vous effectuez une première qualification du prospect selon nos critères.",
        icon: Users
      },
      {
        title: "Transmission",
        description: "Vous nous transmettez le lead qualifié et nous organisons une réunion avec le prospect.",
        icon: Send
      },
      {
        title: "Rémunération",
        description: "Si le lead est validé, vous recevez votre rémunération dans les 7 jours.",
        icon: CheckCircle
      }
    ]
  },
  {
    title: "Processus Contrat",
    icon: FileCheck,
    steps: [
      {
        title: "Identification",
        description: "Vous identifiez un prospect avec un besoin concret et un budget défini.",
        icon: Search
      },
      {
        title: "Accompagnement",
        description: "Vous pouvez soit nous transmettre le lead, soit l'accompagner jusqu'à la signature.",
        icon: Send
      },
      {
        title: "Négociation",
        description: "Nous négocions les termes du contrat avec le prospect, avec ou sans votre participation.",
        icon: Users
      },
      {
        title: "Signature",
        description: "Une fois le contrat signé, vous recevez votre commission selon les termes convenus.",
        icon: Handshake
      }
    ]
  }
];

const ProcessSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Nos Processus
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Des processus clairs et transparents pour une collaboration efficace.
          </p>
        </div>

        <div className="space-y-20">
          {processes.map((process, index) => (
            <div key={index} className="bg-slate-50 rounded-xl p-8">
              <div className="flex items-center gap-4 mb-8">
                <div className="bg-orcsys-50 p-3 rounded-lg">
                  <process.icon className="h-6 w-6 text-orcsys-500" />
                </div>
                <h3 className="text-2xl font-semibold">
                  {process.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {process.steps.map((step, idx) => (
                  <div 
                    key={idx}
                    className="bg-white rounded-xl border border-slate-200 p-6"
                  >
                    <div className="flex items-center gap-4 mb-4">
                      <div className="bg-orcsys-50 p-2 rounded-lg">
                        <step.icon className="h-5 w-5 text-orcsys-500" />
                      </div>
                      <span className="text-orcsys-500 font-semibold">
                        Étape {idx + 1}
                      </span>
                    </div>
                    <h4 className="text-lg font-semibold mb-2">
                      {step.title}
                    </h4>
                    <p className="text-slate-600">
                      {step.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-slate-600 mb-4">
            Nous vous accompagnons à chaque étape pour maximiser vos chances de succès.
          </p>
          <Button 
            size="lg"
            className="bg-orcsys-500 hover:bg-orcsys-600 text-white"
            onClick={() => window.location.href = '/contact'}
          >
            Démarrer la collaboration
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection; 